import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import api from '../middleware/api'
import misc from '../middleware/misc'
import rootReducer from '../reducers'

const configureStore = preloadedState => createStore(
	rootReducer,
	preloadedState,
	applyMiddleware(thunk, api, misc)
)

export default configureStore


// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js